/** A titled block of the trait slide-out: Source, Validity, Where it's used, History. */
function TraitDetailSection({ title, children }) {
  return (
    <section className="flex flex-col gap-2">
      <h3 className="text-xs font-semibold text-content-muted">{title}</h3>
      {children}
    </section>
  );
}

export default TraitDetailSection;
